export default __webpack_public_path__ + "static/media/bestpricelogo.e3eea698.png";